import React from 'react';
import { FILEADD, VIDEOADD } from '../definitions';
import DocumentChecklist from './DocumentChecklist';
import { FileUpload } from './FileUpload';
import { get, first } from 'global/lib/lodash';

export default (props) => {
  const { doc } = props;

  if (!doc) {
    return null;
  }

  const DOC = first(doc) || doc;

  if (DOC.Component) {
    return <DOC.Component {...props} doc={Array.isArray(doc) ? doc : [doc]} />;
  }

  if (doc.documentableType === 'checklist' || doc.documentableType === 'step_by_step') {
    return <DocumentChecklist {...props} />;
  }

  return null;
};
